import { SystemCatalogCategoryTypeSchema } from '@/queries/system_catalog/system_catalog.schema'
import { z } from 'zod'

export const AddItemFormSchema = z.object({
  name: z.string().min(3, { message: 'Name must be at least 3 characters' }),
  categories: z.array(z.string()).min(1, 'Must select at least one category'),
  type: SystemCatalogCategoryTypeSchema,
})

// Create type from the schema

export const EditItemFormSchema = AddItemFormSchema.omit({ type: true })

export type AddItemFormValues = z.infer<typeof AddItemFormSchema>
export type EditItemFormValues = z.infer<typeof EditItemFormSchema>
